export default {
  computed: {
    isDesktop () {
      return this.screenWidth >= 1200
    },
    isTablet () {
      return this.screenWidth <= 1199
    },
    isMobile () {
      return this.screenWidth < 767
    }
  },
  methods: {
    calculateScreenWidth () {
      this.screenWidth = window.innerWidth
    }
  },
  mounted () {
    this.screenWidth = window.innerWidth
    this.$nextTick(function () {
      window.addEventListener('resize', this.calculateScreenWidth)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calculateScreenWidth)
  },
  data () {
    return {
      screenWidth: null
    }
  }
}
